import $ from 'jquery';

export default function () {

    $('.columns2').each(function () {
        if(
            $(this).find('.columns2__left hr').length &&
            $(this).find('.columns2__right hr').length
        ) {
            let firstLeft = $(this).find('.columns2__left > *:first-child');
            let firstRight = $(this).find('.columns2__right > *:first-child');

            firstLeft.css('min-height','auto');
            firstRight.css('min-height','auto');

            if($(window).width() > 768) {
                firstLeft.css('min-height',Math.max(firstLeft.height(),firstRight.height()));
                firstRight.css('min-height',Math.max(firstLeft.height(),firstRight.height()));
            } else {
                firstLeft.css('min-height','auto');
                firstRight.css('min-height','auto');
            }
        }
    });
}